import axios, {
  AxiosError,
  type AxiosInstance,
  type InternalAxiosRequestConfig,
} from 'axios';
import { getAccessToken, refresh, clearSession } from '@/auth/authClient';

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

// Hardcoded for now; future work will source this from JWT claims or a store.
const FUEL_BENCH_CUSTOMER_ID = '97860';

export const api: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: { Accept: 'application/json' },
});

api.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  const token = getAccessToken();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  config.headers['customerid'] = FUEL_BENCH_CUSTOMER_ID;
  return config;
});

function redirectToSignIn(): void {
  // Router basename is /app, so the sign-in route lives at /app/sign-in.
  if (!window.location.pathname.startsWith('/app/sign-in')) {
    window.location.assign('/app/sign-in');
  }
}

api.interceptors.response.use(
  (resp) => resp,
  async (error: AxiosError) => {
    const original = error.config as
      | (InternalAxiosRequestConfig & { _retry?: boolean })
      | undefined;
    const url = original?.url ?? '';

    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !url.includes('/auth/')
    ) {
      original._retry = true;
      const ok = await refresh();
      if (ok) {
        // Re-run through the instance; the request interceptor attaches the fresh token.
        return api(original);
      }
      clearSession();
      redirectToSignIn();
    }

    return Promise.reject(error);
  },
);
